<ng-container [ngSwitch]="type">
  <div
    class="flex flex-col w-full justify-start items-center md:items-start"
    *ngSwitchCase="'customer'"
  >
    <app-key-value-pair
      *ngIf="sageId"
      name="Sage Account Ref"
      [value]="sageId"
    ></app-key-value-pair>
    <div class="flex flex-row" *ngIf="xeroId">
      <a href="https://go.xero.com/Contacts/View/{{ xeroId }}">View on Xero</a>
    </div>
    <div class="flex flex-row" *ngIf="zohoId">
      <a href="https://zoho.com/Contacts/View/{{ xeroId }}">View on Zoho</a>
    </div>
    <app-key-value-pair
      *ngIf="intactId"
      name="Intact Account Code"
      [value]="intactId"
    ></app-key-value-pair>
  </div>
  <ng-container *ngSwitchDefault></ng-container>
</ng-container>
